import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'bg-text-main-inversion flex w-75 max-w-100 min-w-(--screen-min-width) items-center gap-2 p-4 shadow-[0px_0px_12px_0px_rgba(0,0,0,0.07)] max-md:mt-11',
    imageWrapper: 'size-25',
    image: 'size-full object-cover',
    contentWrapper: 'flex-1 overflow-hidden',
    content: 'flex w-full flex-col gap-0.5',
    title:
      'heading-m-bold w-full overflow-hidden text-ellipsis whitespace-nowrap',
    subtitle:
      'heading-s mb-3.5 w-full overflow-hidden text-sm text-ellipsis whitespace-nowrap',
    tabs: 'flex w-full gap-2',
    tab: 'heading-xs bg-bg-items-white min-w-10 rounded-full px-2 py-0.5'
  }
});
